import { lazy, Suspense } from 'react'

import type { ItemId } from '../../itemSlice'

import { ItemBoundary } from '../ItemBoundary/ItemBoundary'
import { ItemCondensedSkeleton } from './ItemCondensedSkeleton'

const ItemCondensedEntry = lazy(() => import('./ItemCondensedEntry'))

export function ItemCondensed({ ids }: { ids?: ItemId[] }) {
  if (!ids) return null

  return (
    <ul className="item-condensed-list twc-flex twc-pb-3 twc-flex-col twc-gap-3 twc-max-h-96 twc-overflow-y-scroll twc-rounded twc-divide-y dark:twc-divide-slate-700">
      {ids.map((id) => (
        <li className="twc-pt-3" key={id}>
          <ItemBoundary id={id}>
            <Suspense fallback={<ItemCondensedSkeleton />}>
              <ItemCondensedEntry id={id} />
            </Suspense>
          </ItemBoundary>
        </li>
      ))}
    </ul>
  )
}
